import { Box, Collapse, IconButton, InputAdornment } from "@mui/material";
import React, { Component } from "react";
import HidePasswordIcon from "../resources/icons-eye-off.svg";
import ShowPasswordIcon from "../resources/icons-eye-on.svg";
import TextField from "./TextField";
import Tooltip from "./Tooltip";

interface PasswordFieldProps {
  label?: string;
  type?: string;
  clearable?: boolean;
  autoComplete?: string;
  showRequirements?: boolean;
}

interface PasswordFieldState {
  showPassword: boolean;
}

export default class PasswordField extends Component<
  PasswordFieldProps,
  PasswordFieldState
> {
  static defaultProps = {
    label: "Password",
    type: "password",
    clearable: false,
    autoComplete: "password",
    showRequirements: false,
  };

  ref: any;

  constructor(props: PasswordFieldProps) {
    super(props);

    this.state = {
      showPassword: false,
    };

    this.ref = React.createRef();
  }

  onShowHidePassword() {
    const { showPassword } = this.state;
    this.setState({ showPassword: !showPassword }, () => {
      if (this.ref)
        this.ref.current.setAttribute(
          "type",
          !showPassword ? "text" : "password"
        );
    });
  }

  render() {
    const { showRequirements } = this.props;
    const { showPassword } = this.state;

    return (
      <div>
        <TextField
          inputRef={this.ref}
          className="klayo-passwordfield"
          {...this.props}
          endAdornment={
            <InputAdornment position="end" sx={{ paddingRight: "4px" }}>
              <Tooltip title={showPassword ? "Show password" : "Hide password"}>
                <IconButton
                  className="klayo-passwordfield_showhidebutton"
                  onClick={this.onShowHidePassword.bind(this)}
                >
                  {showPassword ? <ShowPasswordIcon /> : <HidePasswordIcon />}
                </IconButton>
              </Tooltip>
            </InputAdornment>
          }
        />
        <Collapse in={showRequirements}>
          {showRequirements && (
            <Box
              sx={{ marginTop: "29px" }}
              className="klayo-passwordfield_requirements"
            >
              <div style={{ fontWeight: "500" }}>
                Your password must contain a minimum of 8 characters and at
                least three of the following:
              </div>
              <ul>
                <li>A lowercase letter (e.g. “a”)</li>
                <li>An uppercase letter (e.g. “A”)</li>
                <li>A digit (e.g. “3”)</li>
                <li>A symbol (e.g. “-”)</li>
              </ul>
            </Box>
          )}
        </Collapse>
      </div>
    );
  }
}
